// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Container } from '@mui/material';
import ZapierTokenRow from './ZapierTokenRow';

export default function IntegrationApiTokens() {
    const isHeadCoach = useSelector((state: any) => state.user.headCoach);
    if (!isHeadCoach) {
        return <Redirect to="/" />;
    }

    return (
        <div className="outer-container with-nav">
            <Container maxWidth="lg">
                <div className="zapier-container">
                    <img
                        src="https://static.trainheroic.com/images/ZapierDiagram2021.png"
                        width="100%"
                        alt="Zapier Integrations Diagram"
                    />
                    <ZapierTokenRow />
                </div>
            </Container>
        </div>
    );
}
